import React, { Component } from 'react';
import { Col, Modal, Row } from "antd";
import { injectIntl } from "react-intl";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ExtraPaymentModal.css';
import CloseIcon from '../../../assets/fi_x-circle.svg';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

class ExtraPaymentInfoModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      visible: false,
      monthPay: 0,
      acum: 0,
      showContract: true,
      keyCompartir: true,
      keyHost: true,
      keyAutenticacion: true,
      keyGrupos: true,
    }

    this.props['compRef'].current = this;
  }

  showInfoModal = () => {
    this.setState({
      visible: true,
    });
  };

  closeInfoModal = () => {
    this.setState({
      visible: false
    })
  }

  render() {
    const {
      intl
    } = this.props

    const { visible } = this.state

    return (
      <Modal
        visible={visible}
        onCancel={this.closeInfoModal}
        width={1050}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={'icon close'} />}
      >
        <Row type={'flex'} gutter={[10, 10]} align={'middle'} justify={'space-between'}>
          <Col span={18}>
            <span style={{ fontSize: 30, fontWeight: 700, color: '#3598CD' }}>{intl.formatMessage({ id: 'extra_payment_info.title' })}</span>
          </Col>
          <Col span={6}>

          </Col>
          <Col span={18}>

          </Col>
          <Col span={6}>

          </Col>
          
          <Col span={24} style={{ marginBottom: 70, }}></Col>
        </Row>

        <div
          style={{
            display: 'flex',
            position: 'absolute',
            bottom: 0,
            right: 0,
            left: 0,
            height: 110,
            borderRadius: '20px 20px 5px 5px',
            background: '#ffffff',
            padding: '10px 20px',
            alignItems: 'center',
            boxShadow: '5px -3px 4px rgba(0, 0, 0, 0.1)',
          }}
        >
        
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
  }
}

const mapDispatchToProps = {
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ExtraPaymentInfoModal)))
